export const constructionStatuses = [
  { text: 'Proposed', value: 'proposed' },
  { text: 'Under Construction', value: 'under construction' },
  { text: 'Existing', value: 'existing' },
];
